<div class="row">

  <div class="col-lg-7">
    <button (click)="regresarPagina()" style="width: 100px; height: 40px; padding: 0px; border: 0px;" class="btn btn-outline-info"><i class="fa fa-hand-o-left" style="margin-right: 8px;"></i>Regresar</button>
    <div class="card">
      <div class="card-body">
        <h4 class="card-title">Usuario: <b>{{correoUsuario}}</b>, <i>{{rolUsuario}}</i></h4>
        <form [formGroup]="formularioPerfil" class="form-material m-t-40" (ngSubmit)="ActualizarInformacionPerfil()">

          <div class="row ">
            <div class="col-6">
              <div class="col-xs-6 ">

                <div class="form-group">
                  <label for="nombre">Nombres</label>
                  <div class="input-group">
                    <div class="input-group-addon"></div>
                    <input formControlName="nombre" type="text" required class="form-control" minlength="0" maxlength="200">
                  </div>

                  <div class="alert-danger" *ngIf="nombre.invalid && (nombre.dirty || nombre.touched)" >
                    <div class="container-error-message" *ngIf="nombre.errors.required" >
                      El nombre es requerido
                    </div>
                    <div class="container-error-message" *ngIf="nombre.errors.minlength">
                      El nombre debe tener mínimo 0 caracteres
                    </div>
                    <div class="container-error-message" *ngIf="nombre.errors.maxlength">
                      Excede el número de caracteres permitidos
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label for="apellido">Apellidos</label>
                <div class="input-group">
                  <div class="input-group-addon"></div>
                  <input formControlName="apellido" type="text" required class="form-control" minlength="0" maxlength="200">
                </div>

                <div class="alert-danger" *ngIf="apellido.invalid && (apellido.dirty || apellido.touched)" >
                  <div class="container-error-message" *ngIf="apellido.errors.required" >
                    El apellido es requerido
                  </div>
                  <div class="container-error-message" *ngIf="apellido.errors.minlength">
                    El apellido debe tener mínimo 0 caracteres
                  </div>
                  <div class="container-error-message" *ngIf="apellido.errors.maxlength">
                    Excede el número de caracteres permitidos
                  </div>
                </div>

              </div>
            </div>
          </div>

          <div class="form-group">
            <label for="cedula">Cédula</label>
            <div class="input-group">
              <div class="input-group-addon"></div>
              <input formControlName="cedula" (change)="validarcedula(cedula)" type="text" class="form-control" onkeypress='return event.charCode >= 48 && event.charCode <= 57' minlength="10" maxlength="10">
            </div>

            <div class="alert-danger" *ngIf="cedula.invalid && (cedula.dirty || cedula.touched)" >
              <div class="container-error-message" *ngIf="cedula.errors.required" >
                La cédula es requerida
              </div>
              <div class="container-error-message" *ngIf="cedula.errors.minlength">
                La cédula debe tener mínimo 10 caracteres
              </div>
              <div class="container-error-message" *ngIf="cedula.errors.maxlength">
                Excede el número de caracteres permitidos
              </div>
            </div>
            <div *ngIf="cedulaValidadaConExito===false" class="alert-danger">La cédula no es correcta</div>


          </div>


          <div class="row ">
            <div class="col-6 m-t-10">
              <div class="col-xs-6 ">
                <div class="form-group">
                  <label for="movil">Celular</label>
                  <div class="input-group">
                    <div class="input-group-addon"></div>
                    <input formControlName="movil" type="text" required class="form-control" onkeypress='return event.charCode >= 48 && event.charCode <= 57' minlength="10" maxlength="10" placeholder="Ejm.: 0986523145">
                  </div>

                  <div class="alert-danger" *ngIf="movil.invalid && (movil.dirty || movil.touched)" >
                    <div class="container-error-message" *ngIf="movil.errors.required" >
                      El número de celular es requerido
                    </div>
                    <div class="container-error-message" *ngIf="movil.errors.minlength">
                      El número de celular debe tener mínimo 10 caracteres
                    </div>
                    <div class="container-error-message" *ngIf="movil.errors.maxlength">
                      Excede el número de caracteres permitidos
                    </div>
                    <div class="container-error-message" *ngIf="movil.errors.pattern">
                      El número de celular no es válido
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div class="col-6 m-t-10">
              <div class="form-group">
                <label for="convencional">Convencional</label>
                <div class="input-group">
                  <div class="input-group-addon"></div>
                  <input formControlName="convencional" type="text" class="form-control"
                     onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="7" placeholder="Ejm.: 285646">
                </div>

                <div class="alert-danger" *ngIf="convencional.invalid && (convencional.dirty || convencional.touched)" >
                  <div class="container-error-message" *ngIf="convencional.errors.maxlength">
                    Excede el número de caracteres permitidos
                  </div>
                  <div class="container-error-message" *ngIf="convencional.errors.pattern">
                    El número convencional no es válido
                  </div>
                </div>

              </div>
            </div>
          </div>

          <button type="submit" class="btn btn-block btn-lg btn-info btn-rounded" [disabled]="!formularioPerfil.valid || !cedulaValidadaConExito" >
            Actualizar información</button>
        </form>
      </div>
    </div>
  </div>

  <div class="col-lg-5 m-t-40">
    <div class="card">
      <div class="card-body" align='center'>

        <img *ngIf="!imagenTemporal" [src]="usuario.imagen | imagen" class="w150" alt="">
        <img *ngIf="imagenTemporal" [src]="imagenTemporal" class="w150" alt="">
        <br>
        <br>
        <small><input (change)='seleccionarImagen($event.target.files[0])' type="file"></small>
        <br>
        <br>

        <button (click)='cambiarImagen()' [disabled]='!subirImagen' type="submit"
          class="btn btn-block btn-lg btn-info btn-rounded"> Actualizar Foto</button>

      </div>
    </div>
  </div>
</div>

